    //Varun: TODO: remove it if you see its not been used anywhere.
    angular.module('jv.video.interview.review.controller',[])
    .controller('IntervieweeReviewCtrl',['$scope', 'videoService', '$routeParams',
    function ($scope, videoService, $routeParams) {
        $scope.type = $routeParams.type;
        var interviewId = $routeParams.interviewId;
        // TODO: Not sure what should happen, here need wireframes.
        //      videoService.getAnswerSummary(null, function(result){
        //
        //      });
    }]);
